import Reveal from "../animations/Reveal";
import PeerJudgedBattles from "../../img/home/PeerJudgedBattles.webp";
import ProJudgedBattles from "../../img/home/ProJudgedBattles.webp";
import HeartFace from "../../img/battleFaces/heartCrop.webp";
import WonderFace from "../../img/battleFaces/wonderCrop.webp";
import FearFace from "../../img/battleFaces/fearCrop.webp";
import WinterFace from "../../img/battleFaces/winterCrop.webp";
import SpringFace from "../../img/battleFaces/springCrop.webp";
import SummerFace from "../../img/battleFaces/summerCrop.webp";
import AutumnFace from "../../img/battleFaces/autumnCrop.webp";
import BattleTypeExplanation from "./BattleTypeExplanation";
import BattleFaceWrapper from "./BattleFaceWrapper";
import BattleDatesList from "./BattleDatesList";
import { nightModeStyleWhite } from "../../publicFunctions/publicHelpers/helpers";

function PeerVSPro({ battles, nightMode }) {
  return (
    <div
      style={nightMode ? nightModeStyleWhite : {}}
      className={
        "padding-top-bot--smaller" +
        (nightMode
          ? " purple-background--dark"
          : " purple-background--lightest")
      }
    >
      <div className="container margin-bottom-large">
        <Reveal type="fromBottom" rotate={true}>
          <span className={"subheading" + (nightMode ? " blue" : "")}>
            Two Types of Battles
          </span>
        </Reveal>
        <Reveal type="fromBottom" rotate={true}>
          <h2
            style={nightMode ? nightModeStyleWhite : {}}
            className="heading-secondary margin-bottom-md"
          >
            Peer-Judged and Pro-Judged Battles
          </h2>
        </Reveal>
        <div className="peer-vs-pro">
          <Reveal type="fromLeft" rotate={false}>
            <BattleTypeExplanation
              image={PeerJudgedBattles}
              title="Peer-Judged"
              listOfItems={
                <>
                  <li>
                    All writers read and judge 10 short stories in different
                    Genres than their own
                  </li>
                  <li>The Genres are kept secret until the Battle starts</li>
                  <li>10 bits of feedback by 10 anonymous peer judges</li>
                  <li>Top stories are judged by authors and editors</li>
                </>
              }
              listOfBattleDescriptions={
                <>
                  <BattleFaceWrapper
                    faceImg={SummerFace}
                    title="Summer Battle"
                    words="250"
                    body="two days to write"
                    hideWordCount={false}
                  />
                  <BattleFaceWrapper
                    faceImg={AutumnFace}
                    title="Autumn Battle"
                    words="2000"
                    body="seven days to write"
                    hideWordCount={false}
                  />
                  <BattleFaceWrapper
                    faceImg={WinterFace}
                    title="1000-word Peer Battle"
                    body="eight fun and varied genres"
                  />
                  <BattleFaceWrapper
                    faceImg={SpringFace}
                    title="250-word Peer Battle"
                    body="eight fun and varied genres"
                  />
                </>
              }
            />
          </Reveal>
          <Reveal type="fromRight" rotate={false}>
            <BattleTypeExplanation
              image={ProJudgedBattles}
              title="Professionally-Judged"
              listOfItems={
                <>
                  <li>The entire tournament is judged professionally</li>
                  <li>Guaranteed 3 professionals judge your story</li>
                  <li>Results rollout quickly</li>
                  <li>Opportunity for peer feedback after you submit</li>
                  <li>Top stories are judged by authors and editors</li>
                </>
              }
              listOfBattleDescriptions={
                <>
                  <BattleFaceWrapper
                    faceImg={FearFace}
                    title="Fear Pro Battle"
                    words="1000"
                    body="Horror, Thriller & Suspense, Dystopia, Mystery"
                  />
                  <BattleFaceWrapper
                    faceImg={HeartFace}
                    title="1000-word Pro Battle"
                    body="eight fun and varied genres"
                  />
                  <BattleFaceWrapper
                    faceImg={WonderFace}
                    title="2500-word Pro Battle"
                    body="eight fun and varied genres"
                  />
                </>
              }
            />
          </Reveal>
        </div>
        <BattleDatesList battles={battles} />
      </div>
    </div>
  );
}

export default PeerVSPro;
